import { Text } from "@totalenergiescode/mobility-business-rev-design-system";
import { useTranslation } from "react-i18next";

import { getAccessActionTranslationKeys } from "./helpers";
import {
  StyledButtonsContainerDiv,
  StyledCancelButton,
  StyledConfirmButton,
  StyledContentDiv,
  StyledDrawerContainerDiv,
  StyledInformationContentDiv,
  StyledInformationDescriptionDiv,
  StyledInformationDiv,
  StyledInformationIcon,
  StyledInformationTitleText,
  StyledSelectionCountText,
  StyledSelectionDiv,
  StyledSelectionLabelText,
} from "./styles";
import type { AccessActionDrawerProps } from "./types";

export const AccessActionDrawer = ({
  action,
  accountCount,
  onConfirm,
  onClose,
}: Readonly<AccessActionDrawerProps>) => {
  const { t: tUsers } = useTranslation("users");
  const { t: tCommon } = useTranslation("common");
  const translationKeys = getAccessActionTranslationKeys(action);

  return (
    <StyledDrawerContainerDiv>
      <Text variant='title5'>{tUsers(translationKeys.title)}</Text>

      <StyledContentDiv>
        <StyledSelectionDiv>
          <StyledSelectionLabelText variant='text2'>
            {tUsers("users.list.accessManagement.drawer.selection.label")}
          </StyledSelectionLabelText>
          <StyledSelectionCountText variant='title4'>
            {tUsers("users.list.accessManagement.drawer.selection.account", {
              count: accountCount,
            })}
          </StyledSelectionCountText>
        </StyledSelectionDiv>

        <StyledButtonsContainerDiv>
          <StyledConfirmButton
            variant='primary'
            isLowercase
            buttonText={tUsers("users.list.accessManagement.drawer.confirm")}
            dataTestId='accounts__access-action-drawer-confirm-button'
            onClick={onConfirm ? () => onConfirm(action) : undefined}
          />
          <StyledCancelButton
            variant='secondary'
            isLowercase
            buttonText={tCommon("common.label.cancel")}
            dataTestId='accounts__access-action-drawer-cancel-button'
            onClick={onClose}
          />
        </StyledButtonsContainerDiv>

        <StyledInformationDiv>
          <StyledInformationIcon width={28} height={28} />
          <StyledInformationContentDiv>
            <StyledInformationTitleText variant='title1'>
              {tUsers(translationKeys.informationTitle)}
            </StyledInformationTitleText>
            <StyledInformationDescriptionDiv>
              <Text variant='text1'>
                {tUsers(translationKeys.informationDescription)}
              </Text>
              <Text variant='text1'>
                {tUsers(translationKeys.informationFollowUp)}
              </Text>
            </StyledInformationDescriptionDiv>
          </StyledInformationContentDiv>
        </StyledInformationDiv>
      </StyledContentDiv>
    </StyledDrawerContainerDiv>
  );
};
